import { render, staticRenderFns } from "./LightPage.vue?vue&type=template&id=8552f8a2&scoped=true&"
import script from "./LightPage.vue?vue&type=script&lang=js&"
export * from "./LightPage.vue?vue&type=script&lang=js&"
import style0 from "./LightPage.vue?vue&type=style&index=0&id=8552f8a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8552f8a2",
  null
  
)

export default component.exports